import React from 'react';
// bootstrap
import { Image, Navbar, Nav, Form, Button } from 'react-bootstrap';
// Redux
import { connect } from 'react-redux';
// React-Router
import { Link } from 'react-router-dom';
// component
import app from '../firebase/fire';
// action
import * as actionType from '../../store/action';

function Header({ authChange, email, uid }) {
  const logo =
    'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Flogo.png?alt=media&token=4e101b01-3d27-4d9a-b6ad-18d34988cf36';
  const signOut = async () => {
    try {
      await app.auth().signOut();
      authChange();
    } catch (error) {
      alert(error.message);
    }
  };

  return (
    <>
      {/* main navbar */}
      <Navbar
        collapseOnSelect
        expand='lg'
        // bg='primary'
        variant='dark'
        className='mainNav'
      >
        {/* navbar-logo */}
        <Navbar.Brand href='/login'>
          <div className='d-flex align-items-center'>
            <Image src={logo} fluid className='logo' />
            <h5 className='text-secondary'>ཚང་གསར་ཀུན་དགའ་རིན་པོ་ཆེ།</h5>
          </div>
        </Navbar.Brand>
        <Navbar.Toggle
          aria-controls='responsive-navbar-nav'
          className='border-secondary'
        />
        <Navbar.Collapse id='responsive-navbar-nav'>
          <Nav className='ml-auto'>
            {/*navigation link HOME*/}
            <Nav.Link className='singleNavLink'>
              <Link className='navLink' to='/admin'>
                home
              </Link>
            </Nav.Link>

            {/*  Language Switch Buttons */}
          </Nav>
        </Navbar.Collapse>
      </Navbar>
      <Form inline className='logInBtn bg-secondary p-2'>
        <p className='text-dark ml-auto pr-2'>User: {email}</p>
        <Button onClick={() => signOut()}>Sign Out</Button>
      </Form>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    email: state.auth.email,
    uid: state.auth.uid,
  };
};

const mapActionToProps = (dispatch) => {
  return {
    authChange: () =>
      dispatch({ type: actionType.UPDATE, isLogIn: false, email: '', uid: '' }),
  };
};
export default connect(mapStateToProps, mapActionToProps)(Header);
